(function () {
    'use strict';

    angular.module("imApp").factory("selectShiftService", ['$ihttp', function ($ihttp) {
        let service = {
            listWorkShifts: function (parms) {
                return $ihttp.post({
                    method: 140,
                    parameters: parms || {}
                });
            },
            saveToPrevious: function (item) {
                return $ihttp.post({
                    method: 141,
                    parameters: item
                });
            }
        };

        return service;
    }]);
})();
